import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable } from '@angular/core';

import { UserService } from './../../../app/services/user.service';
import { SentryService } from './sentry.service';

const skipStatus = [0, 403, 500, 502, 503, 504];

@Injectable()
export class SentryErrorHandler implements ErrorHandler {
	constructor(private user: UserService, public sentryService: SentryService) {}

	handleError(error: any) {
		const skipError = this.processError(error);
		if (!skipError) {
			this.sentryService.captureException(error);
		}
	}

	processError(error: any) {
		if (error.rejection && (error.rejection as firebase.auth.Error).code) {
			const err = error.rejection as firebase.auth.Error;
			if (err.code.endsWith('quota-exceeded')) {
				return true;
			}
		}

		error =
			error && error.rejection && error.rejection instanceof HttpErrorResponse
				? error.rejection
				: error;
		if (error instanceof HttpErrorResponse) {
			return skipStatus.includes((error as HttpErrorResponse).status);
		}
		return false;
	}
}
